<template>
    <div>
        <div id="heading" class="row border-bottom fixed-top bg-light py-2">
            <div class="d-none d-lg-block col-12 col-lg-2"></div>
            <div id="top-bar" class="col-12 col-lg-8 d-flex align-items-center">
                <div class="ms-3 me-3">
                    <a href="https://www.ecoesc.org" target="_blank" style="text-decoration: none;">
                        <img src="/img/logo1.svg" alt="Logo" class=""/>
                    </a>
                </div>
                <div class="h3 flex-grow-1 d-none d-md-block">Event Registration</div>
                <div class="h3 flex-grow-1 d-md-none">Events</div>
                <div class="me-1 roboto fw-300">
                    <a href="javascript:void(0)" @click="$router.push('/')">
                        <i class="fas fa-list me-2"></i><span class="d-none d-lg-inline">Event&nbsp;List</span>
                    </a>
                </div>
                <div id="login" class="me-3">
                    <login-button class="ms-3" :user-name="user.Name" :user-member="user.Member"></login-button>
                </div>
            </div>
        </div>
        <div class="container">
            <login-modal></login-modal>
            <div class="row">
                <div class="d-none d-lg-block col-xl-2"></div>
                <main class="col-12 col-xl-8">
                    <router-view></router-view>
                </main>
            </div>
        </div>
        <toast-notification></toast-notification>
    </div>
</template>

<style scoped>
#heading img {
    max-height: 3em;
}

main {
    margin-top: 6em;
}
</style>

<script>
import LoginButton from './components/LoginButton.vue';
import LoginModal from './components/LoginModal.vue';
import ToastNotification from './components/toast.vue';
import axios from 'axios';

export default {
    components: {
        LoginButton,
        LoginModal,
        ToastNotification,
    },

    mounted() {
        this.eventHub.$on('logoutPressed', event => { this.logout(); });
        axios
            .get('/api/user')
            .then(response => {
                this.user = response.data.data;
            })
            .catch(error => {
                console.error(error);
            })
            .finally(() => {
            //    console.log(this.user) ;
            });

    },

    methods: {
        logout: function() {
            this.isLoading = true;
            axios
                .get('/api/logout')
                .then(response => {
                    this.user = {
                        Name: '',
                        Member: false,
                        Id: null,
                    };
                    this.$router.push('/');
                })
                .catch(error => {
                    console.error(error);
                })
                .finally(() => {
                    this.isLoading = false;
                });
        }
    },

    data() {
        return {
            user: {
                Name: '',
                Member: false,
                Id: null,
            },
        };
    }, 
}
</script>

